import React from 'react'
import styled from 'styled-components'
import strawberryImage from '../assets/hero-image.jpg'
import About from './About'
import StandsPage from './StandsPage'
import FeaturedProducts from './FeaturedProducts'
import ContactSection from './ContactSection'
import { Typewriter } from "react-simple-typewriter";
import HighlightsSection from '../components/HighlightsSection'
import TestimonialSection from './TestimonialSection'

const Home = () => {
    return (
        <>
            <title>Wilberries | Ferske Norske Bær i Oslo</title>
            <meta name="description" content="Kjøp ferske norske bær direkte fra våre stands! Ferske norske jordbær, bringebær og moreller levert til deg." />
            <meta name="keywords" content="bær, norske bær, norske jordbær, norske bringebær, norske moreller, ferske bær, wildberries, bær oslo, wildberries norge, wildberries.no" />
            <meta name="author" content="Wildberries AS" />
            <meta property="og:title" content="Wildberries | Ferske, Norske Bær i Oslo" />
            <meta property="og:description" content="Bestill ferske bær fra Wildberries - direkte fra våre stands i Oslo!" />
            <meta property="og:url" content="https://wildberries.no" />


            <HeroSection>
                <TextContainer>
                    <Title>
                        <RedText>Ferske Norske</RedText>
                        <GreenText>
                            <Typewriter 
                                words={["Jordbær", "Bringebær", "Moreller", "Sommer Bær"]}
                                loop={0}
                                cursor
                                cursorStyle="|"
                                typeSpeed={120}
                                deleteSpeed={80}
                                delaySpeed={1500}
                            />
                        </GreenText>
                    </Title>
                    
                    <Description>
                        Opplev smaken av norsk sommer med vårt håndplukkede utvalg av friske jordbær, bringebær og moreller.
                    </Description>

                    <ButtonContainer>
                        <PrimaryButton> <a href='/shop'>Kjøp Nå</a></PrimaryButton>
                        <SecondaryButton><a href='#about'>Les Mer</a></SecondaryButton>
                    </ButtonContainer>
                </TextContainer>

                <ImageContainer>
                    <img src={strawberryImage} alt="Fresh Strawberries" />
                </ImageContainer>
            </HeroSection>

            <FeaturedProducts />
            <HighlightsSection />
            <About />
            <StandsPage />
            <TestimonialSection />
            <ContactSection />
        </>
    )
}

export default Home;


const HeroSection = styled.section`
    display: flex;
    width: 100%;
    max-width: 90%; 
    margin: 0 auto; 
    padding: 0 1.5rem;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    height: 90vh;

    @media (max-width: 1280px) {
        max-width: 90%;
    }

    @media (max-width: 1024px) {
        max-width: 95%;
        flex-direction: column;
        height: auto;
        padding: 3rem 1rem;
    }

    @media (max-width: 768px) {
        max-width: 100%;
        padding: 0 1rem;
    }
`;

const TextContainer = styled.div`
    max-width: 500px;

    @media (max-width: 1024px) {
        max-width: 100%;
    }
`;

const Title = styled.h1`
    font-size: 4rem;
    line-height: 1.2;
    display: flex;
    flex-direction: column;
    font-family: 'Anton', sans-serif;

    @media (max-width: 768px) {
        font-size: 3rem;
        margin-top: 2rem;
    }
`;

const RedText = styled.span`
    color: #b31a1a;
`;

const GreenText = styled.span`
    color: #2d6a4f;
`;

const Description = styled.p`
    font-size: 1.1rem;
    color: #807d7d;
    margin-top: 1rem;

    @media (max-width: 768px) {
        font-size: .9rem;
    }
`;

const ButtonContainer = styled.div`
    margin-top: 1.5rem;
    display: flex;
    gap: 1rem;

`;

const PrimaryButton = styled.button`
    background-color: #b31a1a;
    color: #ffffff;
    padding: 0.8rem 1.5rem;
    font-size: 1rem;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
        background-color: #900;
    }

    @media (max-width: 768px) {
        font-size: .9rem;
    }
    
`;

const SecondaryButton = styled.button`
    background-color: transparent;
    color: #b31a1a;
    padding: 0.8rem 1.5rem;
    font-size: 1rem;
    border: 1px solid #b31a1a;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
        background-color: #b31a1a;
        color: #fff;
    }

    @media (max-width: 768px) {
        font-size: .9rem;
    }
`;

const ImageContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        width: 100%;
        max-width: 800px;
        border-radius: 10px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }

    @media (max-width: 1024px) {
        max-width: 100%;
    }
`;